<template>
  <div class="page-header">
    <div class="d-flex align-center justify-space-between flex-wrap">
      <h3 class="mb-4" v-if="displayTitle">{{ displayTitle }}</h3>
      <div class="d-flex align-center">
        <slot name="topRightSlot"></slot>
      </div>
    </div>
    <div class="d-flex align-center justify-space-between flex-wrap">
      <div class="d-flex align-center">
        <v-btn
          v-if="showBackButton"
          plain
          depressed
          color="black"
          text
          @click="$router.back()"
          class="mr-2 mb-4 px-0"
          :disabled="buttonDisabled"
          :ripple="false"
          style="min-width: unset;"
        >
          <v-icon left class="back-button-icon">{{ mdiChevronLeft }}</v-icon>
          {{ $t('back') }}
        </v-btn>
      </div>
      <div class="d-flex align-center">
        <slot name="botRightSlot"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiChevronLeft } from '@mdi/js'
export default {
  name: 'PageHeader',
  props: {
    showBackButton: {
      required: false,
      type: Boolean,
      default: false,
    },
    isLoading: {
      required: false,
      type: Boolean,
      default: false,
    },
    title: {
      required: false,
      type: String,
      default: '',
    },
  },
  computed: {
    displayTitle() {
      if (this.title) {
        return this.$t(this.title)
      } else if (this.$route.meta && this.$route.meta.showTitleAtSlot) {
        return this.$route.meta.title
      }

      return ''
    },
    buttonDisabled() {
      return this.isLoading || this.$store.getters.isLoading
    },
  },
  data: () => ({
    mdiChevronLeft,
  }),
}
</script>

<style lang="scss" scoped>
.back-button-icon {
  font-size: 14px !important;
}

.page-header {
  width: 100%;
}
</style>
